import type { ShareToChatSubject } from "@xop-any-time/shared";
import type { JSX } from "react";

/**
 * Stub. Chat is XOP staff's internal messenger — its own rooms, its own
 * roster — and a reseller has no account in it, so the dialog never opens
 * here (`buildEntityShareItems` omits the menu item that would).
 *
 * Kept at the source's path so the ported pages that import it stay
 * unedited and diffable.
 */
export interface ShareToChatDialogProps {
  open?: boolean;
  onClose?: () => void;
  subject?: ShareToChatSubject;
}

export function ShareToChatDialog(_props: ShareToChatDialogProps): JSX.Element | null {
  return null;
}

export default ShareToChatDialog;
